// extracted by extract-css-chunks-webpack-plugin
module.exports = {"m-analytics-click":"m-analytics-click___mV_po"};